/* eslint-disable prettier/prettier */
import React, { useMemo } from 'react';
import * as ReactBootstrap from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import Wrapper from '../../../../../../../../shared/components/Wrapper';
import Closed from '../../../../../../../../shared/components/Wrapper/Closed';
import checkValue, {
  convertToReal,
} from '../../../../../../../../utils/values';
import ExportCsv from '../ExportCsv';
import ExportPdf from '../ExportPdf';

function UnifiedReportV2() {
  const closedDataContext = useSelector(
    (reducer: IReducer) => reducer.closedData
  );
  const loading = useMemo(() => {
    if (closedDataContext.isLoading) {
      return (
        <Wrapper.Default margin="5% 0 5% 0" isActive>
          <ReactBootstrap.Spinner animation="border" />
        </Wrapper.Default>
      );
    }
    return <></>;
  }, [closedDataContext.isLoading]);
  return (
    <>
      {loading}
      {closedDataContext.isActive && closedDataContext.partner && (
        <Closed.Container>
          <Closed.Title>RECEBIMENTO DE TRANSFERÊNCIAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de TED</Closed.TInfo>
                <Closed.Info>STR0008R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0008R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Estorno de TED</Closed.TInfo>
                <Closed.Info>STR0010R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0010R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de IF para IF</Closed.TInfo>
                <Closed.Info>STR0006R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0006R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de TED</Closed.TInfo>
                <Closed.Info>STR0007R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0007R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pix</Closed.TInfo>
                <Closed.Info>Pix</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa.Pix
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pix Devolução</Closed.TInfo>
                <Closed.Info>Pix_Devolucao</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .Pix_Devolucao
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>ENVIO DE TRANSFERÊNCIAS EXTERNAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pix</Closed.TInfo>
                <Closed.Info>Pix</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_externa.Pix
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pix Devolução</Closed.TInfo>
                <Closed.Info>Pix_Devolucao</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_externa
                        .Pix_Devolucao
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TED</Closed.TInfo>
                <Closed.Info>STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_externa.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Fluxo de Crédito - CIP</Closed.TInfo>
                <Closed.Info>ASLC022</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_domicilio_bancario.ASLC022
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Fluxo de Débito - CIP</Closed.TInfo>
                <Closed.Info>ASLC024</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_domicilio_bancario.ASLC024
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Fluxo de Antecipação - CIP</Closed.TInfo>
                <Closed.Info>ASLC032</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_domicilio_bancario.ASLC032
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>ENVIO DE TRANSFERÊNCIAS INTERNAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TEV Interna</Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_interna.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>
            ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS DE TERCEIRO
          </Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TEV Interna</Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_interna.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>
            RECEBIMENTO DE TRANSFERÊNCIAS INTERNAS DE CONTAS FIDÚCIA
          </Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TEV Interna</Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext
                        .recebimento_transferencia_interna_conta_fiducia.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE TARIFAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de Pix</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_PIX</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_tarifas.TARIFA_PIX)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">TAXA_TED</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_tarifas.TAXA_TED)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de boleto liquidado</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_BOLETO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_BOLETO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de mensalidade</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_MENSAL</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_MENSAL
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta PF</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_PF
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_PF
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta PJ</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_PJ
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_PJ
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta escrow</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_ESCROW
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_ESCROW
                    )
                  )}
                </Closed.Info>
              </Closed.Column>

              <Closed.Column>
                <Closed.TInfo>
                  Tarifa para geração de QRCODE no Pix
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_PIX_GERAR_QRCODE
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_PIX_GERAR_QRCODE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>

              <Closed.Column>
                <Closed.TInfo>Tarifa para venda de cripto</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CRIPTO_VENDA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_CRIPTO_VENDA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa para compra de cripto</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CRIPTO_COMPRA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_CRIPTO_COMPRA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Tarifa de abertura de conta consignada
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_CONSIGNADA
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_CONSIGNADA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>

              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento de Pix</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_PIX
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_PIX
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento Pix Devolução</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TED
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_TED
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TEV</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TEV
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_TEV
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento Boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_BOLETO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_BOLETO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Tarifa de recebimento Domicílio bancário
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_DOMICILIO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_DOMICILIO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>

              <Closed.Column>
                <Closed.TInfo>Tarifa de solicitação de Cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_CARTAO_SOLICITACAO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_CARTAO_SOLICITACAO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de saque no Cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CARTAO_SAQUE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_CARTAO_SAQUE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>REPASSE DE TARIFAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">TAXA_TED</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TAXA_TED)
                  )}
                </Closed.Info>
              </Closed.Column>

              <Closed.Column>
                <Closed.TInfo>Tarifa de Pix</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_PIX</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TARIFA_PIX)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa genérica</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TARIFA)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de boleto vencido</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_BOLETO_VENCIDO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_BOLETO_VENCIDO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de boleto liquidado</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_BOLETO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TARIFA_BOLETO)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de mensalidade</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_MENSAL</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TARIFA_MENSAL)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de alteração de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ALTERACAO_BOLETO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_ALTERACAO_BOLETO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de boleto baixado</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_BAIXADO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TARIFA_BAIXADO)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta PF</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_PF
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_PF
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta PJ</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_PJ
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_ABERTURA_CONTA_PJ
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta escrow</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_ESCROW
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas
                        .TARIFA_ABERTURA_CONTA_ESCROW
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento de Pix</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_PIX
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_RECEBIMENTO_PIX
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TED
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_RECEBIMENTO_TED
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TEV</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TEV
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_RECEBIMENTO_TEV
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento Boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_BOLETO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas
                        .TARIFA_RECEBIMENTO_BOLETO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Tarifa de recebimento Domicílio bancário
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_DOMICILIO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas
                        .TARIFA_RECEBIMENTO_DOMICILIO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento Pix Devolução</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas
                        .TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TED
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_TED
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TEV</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TEV
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_TEV
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento Boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_BOLETO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_BOLETO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Tarifa de recebimento Domicílio bancário
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_DOMICILIO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_DOMICILIO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de venda Cripto</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CRIPTO_VENDA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_CRIPTO_VENDA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de compra Cripto</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CRIPTO_COMPRA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_CRIPTO_COMPRA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Tarifa de abertura de conta consignada
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_CONSIGNADA
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas
                        .TARIFA_ABERTURA_CONTA_CONSIGNADA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de saque no Cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CARTAO_SAQUE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_CARTAO_SAQUE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de solicitação de Cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_CARTAO_SOLICITACAO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas
                        .TARIFA_CARTAO_SOLICITACAO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa gerar QRCode</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_PIX_GERAR_QRCODE
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.repasse_tarifas.TARIFA_PIX_GERAR_QRCODE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>PAGAMENTO DE BOLETOS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pagamento de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">BOLETO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.pagamento_boleto.Boleto)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE PAGAMENTO DE BOLETOS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">BOLETO_CREDITO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_boleto.BOLETO_CREDITO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>PAGAMENTO DE RECARGAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recarga</Closed.TInfo>
                <Closed.Info color="#18A3A8">Recarga</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.pagamento_recarga.Recarga)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE RECARGA</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recarga</Closed.TInfo>
                <Closed.Info color="#18A3A8">Recarga</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_recarga.Recarga)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>ENVIO CARTÃO</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Compra via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">CARTAO_00_PURCHASE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_cartao.CARTAO_00_PURCHASE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Saque via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  CARTAO_01_CASH_WITHDRAW
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_cartao.CARTAO_01_CASH_WITHDRAW
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Action>
            <Closed.ButtonContainer>
              <ExportCsv
                data={closedDataContext}
                title="CSV Relatório Unificado"
              />
              <ExportPdf
                data={closedDataContext}
                title="PDF Relatório Unificado"
              />
            </Closed.ButtonContainer>
          </Closed.Action>
        </Closed.Container>
      )}

      {closedDataContext.isActive && !closedDataContext.partner && (
        <Closed.Container>
          <Closed.Title>RECEBIMENTO DE TRANSFERÊNCIAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de TED</Closed.TInfo>
                <Closed.Info>STR0008R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0008R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Estorno de TED</Closed.TInfo>
                <Closed.Info>STR0010R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0010R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de IF para IF</Closed.TInfo>
                <Closed.Info>STR0006R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0006R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de TED</Closed.TInfo>
                <Closed.Info>STR0007R2</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0007R2
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pix</Closed.TInfo>
                <Closed.Info>Pix</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa.Pix
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Recebimento de TRANSFERÊNCIAS de outra IF
                </Closed.TInfo>
                <Closed.Info>STR0004R2 (FGTS)</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0004R2_FGTS
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Recebimento de TRANSFERÊNCIAS de outra IF
                </Closed.TInfo>
                <Closed.Info>STR0004R2 (FIDÚCIA INVEST)</Closed.Info>
                <Closed.Info color="#18A3A8">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_transferencia_externa
                        .STR0004R2_INVEST
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>ENVIO DE TRANSFERÊNCIAS EXTERNAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pix</Closed.TInfo>
                <Closed.Info>Pix</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_externa.Pix
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pix Devolução</Closed.TInfo>
                <Closed.Info>Pix_Devolucao</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_externa
                        .Pix_Devolucao
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TEV Interna</Closed.TInfo>
                <Closed.Info>STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_externa.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE DOMICÍLIO BANCÁRIO</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Fluxo de Crédito - CIP</Closed.TInfo>
                <Closed.Info>ASLC022</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_domicilio_bancario.ASLC022
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Fluxo de Débito - CIP</Closed.TInfo>
                <Closed.Info>ASLC024</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_domicilio_bancario.ASLC024
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Fluxo de Antecipação - CIP</Closed.TInfo>
                <Closed.Info>ASLC032</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_domicilio_bancario.ASLC032
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>ENVIO DE TRANSFERÊNCIAS INTERNAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TEV Interna</Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_transferencia_interna.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>
            ENVIO DE TRANSFERÊNCIAS INTERNAS PARA CONTAS DE TERCEIROS
          </Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TEV Interna</Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext
                        .envio_transferencia_interna_conta_terceiros.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>
            RECEBIMENTO DE TRANSFERÊNCIAS INTERNAS DE CONTAS FIDÚCIA
          </Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TEV Interna</Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0008</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext
                        .recebimento_transferencia_interna_conta_fiducia.STR0008
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE TARIFAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de Pix</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_PIX</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_tarifas.TARIFA_PIX)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Recebimento de TRANSFERÊNCIAS para outra IF
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0004R2 (TIB)</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_tarifas.STR0004R2)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">TAXA_TED</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_tarifas.TAXA_TED)
                  )}
                </Closed.Info>
              </Closed.Column>

              <Closed.Column>
                <Closed.TInfo>Tarifa genérica</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_tarifas.TARIFA)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de boleto vencido</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_BOLETO_VENCIDO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_BOLETO_VENCIDO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de mensalidade</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_MENSAL</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_MENSAL
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de alteração de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ALTERACAO_BOLETO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ALTERACAO_BOLETO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de boleto baixado</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_BAIXADO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_BAIXADO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta PF</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_PF
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_PF
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta PJ</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_PJ
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_PJ
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de abertura de conta escrow</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_ESCROW
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_ESCROW
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Tarifa de abertura de conta consignada
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_ABERTURA_CONTA_CONSIGNADA
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_ABERTURA_CONTA_CONSIGNADA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento de Pix</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_PIX
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_PIX
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento Pix Devolução</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_PIX_DEVOLUCAO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TED
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_TED
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento TEV</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_TEV
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_TEV
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>
                  Tarifa de recebimento Domicílio bancário
                </Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_DOMICILIO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_DOMICILIO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de recebimento Boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_RECEBIMENTO_BOLETO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_RECEBIMENTO_BOLETO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de venda Cripto</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CRIPTO_VENDA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_CRIPTO_VENDA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de compra Cripto</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CRIPTO_COMPRA</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_CRIPTO_COMPRA
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de saque no Cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_CARTAO_SAQUE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas.TARIFA_CARTAO_SAQUE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de solicitação de Cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_CARTAO_SOLICITACAO
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_CARTAO_SOLICITACAO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa gerar QRCode</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  TARIFA_PIX_GERAR_QRCODE
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_tarifas
                        .TARIFA_PIX_GERAR_QRCODE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>REPASSE/PAGAMENTO DE TARIFAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa de TED</Closed.TInfo>
                <Closed.Info color="#18A3A8">TAXA_TED</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TAXA_TED)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa Banco Central</Closed.TInfo>
                <Closed.Info color="#18A3A8">SLB0002</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.SLB0002)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>TIB</Closed.TInfo>
                <Closed.Info color="#18A3A8">STR0004 (TIB)</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.STR0004)
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Tarifa Pix</Closed.TInfo>
                <Closed.Info color="#18A3A8">TARIFA_PIX</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.repasse_tarifas.TARIFA_PIX)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE BOLETO ITAÚ</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">BOLETO_CREDITO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_boleto_itau.BOLETO_CREDITO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE BOLETOS CONTA FIDÚCIA</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">BOLETO_CREDITO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_boleto_fiducia
                        .BOLETO_CREDITO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>BOLETOS LIQUIDADOS PARA TERCEIROS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Boletos liquidados para terceiros</Closed.TInfo>
                <Closed.Info color="#18A3A8">BOLETO_CREDITO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_boleto_terceiros
                        .BOLETO_CREDITO
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>PAGAMENTO DE BOLETOS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Pagamento de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">BOLETO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.pagamento_boleto.Boleto)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE PAGAMENTO DE BOLETOS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recebimento de boleto</Closed.TInfo>
                <Closed.Info color="#18A3A8">BOLETO</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_boleto.Boleto)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>Envio do Cartão</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Compra via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">CARTAO_00_PURCHASE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_cartao.CARTAO_00_PURCHASE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO CARTÃO</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Compra via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">CARTAO_00_PURCHASE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_cartao.CARTAO_00_PURCHASE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>PAGAMENTO DE RECARGAS</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recarga</Closed.TInfo>
                <Closed.Info color="#18A3A8">Recarga</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.pagamento_recarga.Recarga)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO DE RECARGA</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Recarga</Closed.TInfo>
                <Closed.Info color="#18A3A8">Recarga</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(closedDataContext.recebimento_recarga.Recarga)
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>ENVIO CARTÃO</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Compra via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">CARTAO_00_PURCHASE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_cartao.CARTAO_00_PURCHASE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Saque via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  CARTAO_01_CASH_WITHDRAW
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.envio_cartao.CARTAO_01_CASH_WITHDRAW
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>
          <Closed.Title>RECEBIMENTO CARTÃO</Closed.Title>
          <Closed.Default>
            <Closed.Body>
              <Closed.Column>
                <Closed.SubHead>DESCRIÇÃO</Closed.SubHead>
                <Closed.SubHead>CÓDIGO</Closed.SubHead>
                <Closed.SubHead>VALOR</Closed.SubHead>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Compra via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">CARTAO_00_PURCHASE</Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_cartao.CARTAO_00_PURCHASE
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
              <Closed.Column>
                <Closed.TInfo>Saque via cartão</Closed.TInfo>
                <Closed.Info color="#18A3A8">
                  CARTAO_01_CASH_WITHDRAW
                </Closed.Info>
                <Closed.Info color="#B83A30">
                  {convertToReal(
                    checkValue(
                      closedDataContext.recebimento_cartao
                        .CARTAO_01_CASH_WITHDRAW
                    )
                  )}
                </Closed.Info>
              </Closed.Column>
            </Closed.Body>
          </Closed.Default>

          <Closed.Action>
            <Closed.ButtonContainer>
              <ExportCsv
                data={closedDataContext}
                title="CSV Relatório Unificado"
              />
              <ExportPdf
                data={closedDataContext}
                title="PDF Relatório Unificado"
              />
            </Closed.ButtonContainer>
          </Closed.Action>
        </Closed.Container>
      )}
    </>
  );
}

export default UnifiedReportV2;
